import { render } from "./RegularButton.vue?vue&type=template&id=20d12e90"
import script from "./RegularButton.vue?vue&type=script&lang=js"
export * from "./RegularButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gary/vhosts/confzilla_root/confzilla/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__